export const regencies = [
  {
    id: '1101',
    provinceId: '11',
    name: 'Kabupaten Simeulue',
  },
  {
    id: '1102',
    provinceId: '11',
    name: 'Kabupaten Aceh Singkil',
  },
  {
    id: '1103',
    provinceId: '11',
    name: 'Kabupaten Aceh Selatan',
  },
  {
    id: '1104',
    provinceId: '11',
    name: 'Kabupaten Aceh Tenggara',
  },
  {
    id: '1105',
    provinceId: '11',
    name: 'Kabupaten Aceh Timur',
  },
  {
    id: '1106',
    provinceId: '11',
    name: 'Kabupaten Aceh Tengah',
  },
  {
    id: '1107',
    provinceId: '11',
    name: 'Kabupaten Aceh Barat',
  },
  {
    id: '1108',
    provinceId: '11',
    name: 'Kabupaten Aceh Besar',
  },
  {
    id: '1109',
    provinceId: '11',
    name: 'Kabupaten Pidie',
  },
  {
    id: '1110',
    provinceId: '11',
    name: 'Kabupaten Bireuen',
  },
  {
    id: '1111',
    provinceId: '11',
    name: 'Kabupaten Aceh Utara',
  },
  {
    id: '1112',
    provinceId: '11',
    name: 'Kabupaten Aceh Barat Daya',
  },
  {
    id: '1113',
    provinceId: '11',
    name: 'Kabupaten Gayo Lues',
  },
  {
    id: '1114',
    provinceId: '11',
    name: 'Kabupaten Aceh Tamiang',
  },
  {
    id: '1115',
    provinceId: '11',
    name: 'Kabupaten Nagan Raya',
  },
  {
    id: '1116',
    provinceId: '11',
    name: 'Kabupaten Aceh Jaya',
  },
  {
    id: '1117',
    provinceId: '11',
    name: 'Kabupaten Bener Meriah',
  },
  {
    id: '1118',
    provinceId: '11',
    name: 'Kabupaten Pidie Jaya',
  },
  {
    id: '1171',
    provinceId: '11',
    name: 'Kota Banda Aceh',
  },
  {
    id: '1172',
    provinceId: '11',
    name: 'Kota Sabang',
  },
  {
    id: '1173',
    provinceId: '11',
    name: 'Kota Langsa',
  },
  {
    id: '1174',
    provinceId: '11',
    name: 'Kota Lhokseumawe',
  },
  {
    id: '1175',
    provinceId: '11',
    name: 'Kota Subulussalam',
  },
  {
    id: '1201',
    provinceId: '12',
    name: 'Kabupaten Nias',
  },
  {
    id: '1202',
    provinceId: '12',
    name: 'Kabupaten Mandailing Natal',
  },
  {
    id: '1203',
    provinceId: '12',
    name: 'Kabupaten Tapanuli Selatan',
  },
  {
    id: '1204',
    provinceId: '12',
    name: 'Kabupaten Tapanuli Tengah',
  },
  {
    id: '1205',
    provinceId: '12',
    name: 'Kabupaten Tapanuli Utara',
  },
  {
    id: '1206',
    provinceId: '12',
    name: 'Kabupaten Toba Samosir',
  },
  {
    id: '1207',
    provinceId: '12',
    name: 'Kabupaten Labuhan Batu',
  },
  {
    id: '1208',
    provinceId: '12',
    name: 'Kabupaten Asahan',
  },
  {
    id: '1209',
    provinceId: '12',
    name: 'Kabupaten Simalungun',
  },
  {
    id: '1210',
    provinceId: '12',
    name: 'Kabupaten Dairi',
  },
  {
    id: '1211',
    provinceId: '12',
    name: 'Kabupaten Karo',
  },
  {
    id: '1212',
    provinceId: '12',
    name: 'Kabupaten Deli Serdang',
  },
  {
    id: '1213',
    provinceId: '12',
    name: 'Kabupaten Langkat',
  },
  {
    id: '1214',
    provinceId: '12',
    name: 'Kabupaten Nias Selatan',
  },
  {
    id: '1215',
    provinceId: '12',
    name: 'Kabupaten Humbang Hasundutan',
  },
  {
    id: '1216',
    provinceId: '12',
    name: 'Kabupaten Pakpak Bharat',
  },
  {
    id: '1217',
    provinceId: '12',
    name: 'Kabupaten Samosir',
  },
  {
    id: '1218',
    provinceId: '12',
    name: 'Kabupaten Serdang Bedagai',
  },
  {
    id: '1219',
    provinceId: '12',
    name: 'Kabupaten Batu Bara',
  },
  {
    id: '1220',
    provinceId: '12',
    name: 'Kabupaten Padang Lawas Utara',
  },
  {
    id: '1221',
    provinceId: '12',
    name: 'Kabupaten Padang Lawas',
  },
  {
    id: '1222',
    provinceId: '12',
    name: 'Kabupaten Labuhan Batu Selatan',
  },
  {
    id: '1223',
    provinceId: '12',
    name: 'Kabupaten Labuhan Batu Utara',
  },
  {
    id: '1224',
    provinceId: '12',
    name: 'Kabupaten Nias Utara',
  },
  {
    id: '1225',
    provinceId: '12',
    name: 'Kabupaten Nias Barat',
  },
  {
    id: '1271',
    provinceId: '12',
    name: 'Kota Sibolga',
  },
  {
    id: '1272',
    provinceId: '12',
    name: 'Kota Tanjung Balai',
  },
  {
    id: '1273',
    provinceId: '12',
    name: 'Kota Pematang Siantar',
  },
  {
    id: '1274',
    provinceId: '12',
    name: 'Kota Tebing Tinggi',
  },
  {
    id: '1275',
    provinceId: '12',
    name: 'Kota Medan',
  },
  {
    id: '1276',
    provinceId: '12',
    name: 'Kota Binjai',
  },
  {
    id: '1277',
    provinceId: '12',
    name: 'Kota Padangsidimpuan',
  },
  {
    id: '1278',
    provinceId: '12',
    name: 'Kota Gunungsitoli',
  },
  {
    id: '1301',
    provinceId: '13',
    name: 'Kabupaten Kepulauan Mentawai',
  },
  {
    id: '1302',
    provinceId: '13',
    name: 'Kabupaten Pesisir Selatan',
  },
  {
    id: '1303',
    provinceId: '13',
    name: 'Kabupaten Solok',
  },
  {
    id: '1304',
    provinceId: '13',
    name: 'Kabupaten Sijunjung',
  },
  {
    id: '1305',
    provinceId: '13',
    name: 'Kabupaten Tanah Datar',
  },
  {
    id: '1306',
    provinceId: '13',
    name: 'Kabupaten Padang Pariaman',
  },
  {
    id: '1307',
    provinceId: '13',
    name: 'Kabupaten Agam',
  },
  {
    id: '1308',
    provinceId: '13',
    name: 'Kabupaten Lima Puluh Kota',
  },
  {
    id: '1309',
    provinceId: '13',
    name: 'Kabupaten Pasaman',
  },
  {
    id: '1310',
    provinceId: '13',
    name: 'Kabupaten Solok Selatan',
  },
  {
    id: '1311',
    provinceId: '13',
    name: 'Kabupaten Dharmasraya',
  },
  {
    id: '1312',
    provinceId: '13',
    name: 'Kabupaten Pasaman Barat',
  },
  {
    id: '1371',
    provinceId: '13',
    name: 'Kota Padang',
  },
  {
    id: '1372',
    provinceId: '13',
    name: 'Kota Solok',
  },
  {
    id: '1373',
    provinceId: '13',
    name: 'Kota Sawah Lunto',
  },
  {
    id: '1374',
    provinceId: '13',
    name: 'Kota Padang Panjang',
  },
  {
    id: '1375',
    provinceId: '13',
    name: 'Kota Bukittinggi',
  },
  {
    id: '1376',
    provinceId: '13',
    name: 'Kota Payakumbuh',
  },
  {
    id: '1377',
    provinceId: '13',
    name: 'Kota Pariaman',
  },
  {
    id: '1401',
    provinceId: '14',
    name: 'Kabupaten Kuantan Singingi',
  },
  {
    id: '1402',
    provinceId: '14',
    name: 'Kabupaten Indragiri Hulu',
  },
  {
    id: '1403',
    provinceId: '14',
    name: 'Kabupaten Indragiri Hilir',
  },
  {
    id: '1404',
    provinceId: '14',
    name: 'Kabupaten Pelalawan',
  },
  {
    id: '1405',
    provinceId: '14',
    name: 'Kabupaten S I A K',
  },
  {
    id: '1406',
    provinceId: '14',
    name: 'Kabupaten Kampar',
  },
  {
    id: '1407',
    provinceId: '14',
    name: 'Kabupaten Rokan Hulu',
  },
  {
    id: '1408',
    provinceId: '14',
    name: 'Kabupaten Bengkalis',
  },
  {
    id: '1409',
    provinceId: '14',
    name: 'Kabupaten Rokan Hilir',
  },
  {
    id: '1410',
    provinceId: '14',
    name: 'Kabupaten Kepulauan Meranti',
  },
  {
    id: '1471',
    provinceId: '14',
    name: 'Kota Pekanbaru',
  },
  {
    id: '1473',
    provinceId: '14',
    name: 'Kota D U M A I',
  },
  {
    id: '1501',
    provinceId: '15',
    name: 'Kabupaten Kerinci',
  },
  {
    id: '1502',
    provinceId: '15',
    name: 'Kabupaten Merangin',
  },
  {
    id: '1503',
    provinceId: '15',
    name: 'Kabupaten Sarolangun',
  },
  {
    id: '1504',
    provinceId: '15',
    name: 'Kabupaten Batang Hari',
  },
  {
    id: '1505',
    provinceId: '15',
    name: 'Kabupaten Muaro Jambi',
  },
  {
    id: '1506',
    provinceId: '15',
    name: 'Kabupaten Tanjung Jabung Timur',
  },
  {
    id: '1507',
    provinceId: '15',
    name: 'Kabupaten Tanjung Jabung Barat',
  },
  {
    id: '1508',
    provinceId: '15',
    name: 'Kabupaten Tebo',
  },
  {
    id: '1509',
    provinceId: '15',
    name: 'Kabupaten Bungo',
  },
  {
    id: '1571',
    provinceId: '15',
    name: 'Kota Jambi',
  },
  {
    id: '1572',
    provinceId: '15',
    name: 'Kota Sungai Penuh',
  },
  {
    id: '1601',
    provinceId: '16',
    name: 'Kabupaten Ogan Komering Ulu',
  },
  {
    id: '1602',
    provinceId: '16',
    name: 'Kabupaten Ogan Komering Ilir',
  },
  {
    id: '1603',
    provinceId: '16',
    name: 'Kabupaten Muara Enim',
  },
  {
    id: '1604',
    provinceId: '16',
    name: 'Kabupaten Lahat',
  },
  {
    id: '1605',
    provinceId: '16',
    name: 'Kabupaten Musi Rawas',
  },
  {
    id: '1606',
    provinceId: '16',
    name: 'Kabupaten Musi Banyuasin',
  },
  {
    id: '1607',
    provinceId: '16',
    name: 'Kabupaten Banyu Asin',
  },
  {
    id: '1608',
    provinceId: '16',
    name: 'Kabupaten Ogan Komering Ulu Selatan',
  },
  {
    id: '1609',
    provinceId: '16',
    name: 'Kabupaten Ogan Komering Ulu Timur',
  },
  {
    id: '1610',
    provinceId: '16',
    name: 'Kabupaten Ogan Ilir',
  },
  {
    id: '1611',
    provinceId: '16',
    name: 'Kabupaten Empat Lawang',
  },
  {
    id: '1612',
    provinceId: '16',
    name: 'Kabupaten Penukal Abab Lematang Ilir',
  },
  {
    id: '1613',
    provinceId: '16',
    name: 'Kabupaten Musi Rawas Utara',
  },
  {
    id: '1671',
    provinceId: '16',
    name: 'Kota Palembang',
  },
  {
    id: '1672',
    provinceId: '16',
    name: 'Kota Prabumulih',
  },
  {
    id: '1673',
    provinceId: '16',
    name: 'Kota Pagar Alam',
  },
  {
    id: '1674',
    provinceId: '16',
    name: 'Kota Lubuklinggau',
  },
  {
    id: '1701',
    provinceId: '17',
    name: 'Kabupaten Bengkulu Selatan',
  },
  {
    id: '1702',
    provinceId: '17',
    name: 'Kabupaten Rejang Lebong',
  },
  {
    id: '1703',
    provinceId: '17',
    name: 'Kabupaten Bengkulu Utara',
  },
  {
    id: '1704',
    provinceId: '17',
    name: 'Kabupaten Kaur',
  },
  {
    id: '1705',
    provinceId: '17',
    name: 'Kabupaten Seluma',
  },
  {
    id: '1706',
    provinceId: '17',
    name: 'Kabupaten Mukomuko',
  },
  {
    id: '1707',
    provinceId: '17',
    name: 'Kabupaten Lebong',
  },
  {
    id: '1708',
    provinceId: '17',
    name: 'Kabupaten Kepahiang',
  },
  {
    id: '1709',
    provinceId: '17',
    name: 'Kabupaten Bengkulu Tengah',
  },
  {
    id: '1771',
    provinceId: '17',
    name: 'Kota Bengkulu',
  },
  {
    id: '1801',
    provinceId: '18',
    name: 'Kabupaten Lampung Barat',
  },
  {
    id: '1802',
    provinceId: '18',
    name: 'Kabupaten Tanggamus',
  },
  {
    id: '1803',
    provinceId: '18',
    name: 'Kabupaten Lampung Selatan',
  },
  {
    id: '1804',
    provinceId: '18',
    name: 'Kabupaten Lampung Timur',
  },
  {
    id: '1805',
    provinceId: '18',
    name: 'Kabupaten Lampung Tengah',
  },
  {
    id: '1806',
    provinceId: '18',
    name: 'Kabupaten Lampung Utara',
  },
  {
    id: '1807',
    provinceId: '18',
    name: 'Kabupaten Way Kanan',
  },
  {
    id: '1808',
    provinceId: '18',
    name: 'Kabupaten Tulangbawang',
  },
  {
    id: '1809',
    provinceId: '18',
    name: 'Kabupaten Pesawaran',
  },
  {
    id: '1810',
    provinceId: '18',
    name: 'Kabupaten Pringsewu',
  },
  {
    id: '1811',
    provinceId: '18',
    name: 'Kabupaten Mesuji',
  },
  {
    id: '1812',
    provinceId: '18',
    name: 'Kabupaten Tulang Bawang Barat',
  },
  {
    id: '1813',
    provinceId: '18',
    name: 'Kabupaten Pesisir Barat',
  },
  {
    id: '1871',
    provinceId: '18',
    name: 'Kota Bandar Lampung',
  },
  {
    id: '1872',
    provinceId: '18',
    name: 'Kota Metro',
  },
  {
    id: '1901',
    provinceId: '19',
    name: 'Kabupaten Bangka',
  },
  {
    id: '1902',
    provinceId: '19',
    name: 'Kabupaten Belitung',
  },
  {
    id: '1903',
    provinceId: '19',
    name: 'Kabupaten Bangka Barat',
  },
  {
    id: '1904',
    provinceId: '19',
    name: 'Kabupaten Bangka Tengah',
  },
  {
    id: '1905',
    provinceId: '19',
    name: 'Kabupaten Bangka Selatan',
  },
  {
    id: '1906',
    provinceId: '19',
    name: 'Kabupaten Belitung Timur',
  },
  {
    id: '1971',
    provinceId: '19',
    name: 'Kota Pangkal Pinang',
  },
  {
    id: '2101',
    provinceId: '21',
    name: 'Kabupaten Karimun',
  },
  {
    id: '2102',
    provinceId: '21',
    name: 'Kabupaten Bintan',
  },
  {
    id: '2103',
    provinceId: '21',
    name: 'Kabupaten Natuna',
  },
  {
    id: '2104',
    provinceId: '21',
    name: 'Kabupaten Lingga',
  },
  {
    id: '2105',
    provinceId: '21',
    name: 'Kabupaten Kepulauan Anambas',
  },
  {
    id: '2171',
    provinceId: '21',
    name: 'Kota B A T A M',
  },
  {
    id: '2172',
    provinceId: '21',
    name: 'Kota Tanjung Pinang',
  },
  {
    id: '3101',
    provinceId: '31',
    name: 'Kabupaten Kepulauan Seribu',
  },
  {
    id: '3171',
    provinceId: '31',
    name: 'Kota Jakarta Selatan',
  },
  {
    id: '3172',
    provinceId: '31',
    name: 'Kota Jakarta Timur',
  },
  {
    id: '3173',
    provinceId: '31',
    name: 'Kota Jakarta Pusat',
  },
  {
    id: '3174',
    provinceId: '31',
    name: 'Kota Jakarta Barat',
  },
  {
    id: '3175',
    provinceId: '31',
    name: 'Kota Jakarta Utara',
  },
  {
    id: '3201',
    provinceId: '32',
    name: 'Kabupaten Bogor',
  },
  {
    id: '3202',
    provinceId: '32',
    name: 'Kabupaten Sukabumi',
  },
  {
    id: '3203',
    provinceId: '32',
    name: 'Kabupaten Cianjur',
  },
  {
    id: '3204',
    provinceId: '32',
    name: 'Kabupaten Bandung',
  },
  {
    id: '3205',
    provinceId: '32',
    name: 'Kabupaten Garut',
  },
  {
    id: '3206',
    provinceId: '32',
    name: 'Kabupaten Tasikmalaya',
  },
  {
    id: '3207',
    provinceId: '32',
    name: 'Kabupaten Ciamis',
  },
  {
    id: '3208',
    provinceId: '32',
    name: 'Kabupaten Kuningan',
  },
  {
    id: '3209',
    provinceId: '32',
    name: 'Kabupaten Cirebon',
  },
  {
    id: '3210',
    provinceId: '32',
    name: 'Kabupaten Majalengka',
  },
  {
    id: '3211',
    provinceId: '32',
    name: 'Kabupaten Sumedang',
  },
  {
    id: '3212',
    provinceId: '32',
    name: 'Kabupaten Indramayu',
  },
  {
    id: '3213',
    provinceId: '32',
    name: 'Kabupaten Subang',
  },
  {
    id: '3214',
    provinceId: '32',
    name: 'Kabupaten Purwakarta',
  },
  {
    id: '3215',
    provinceId: '32',
    name: 'Kabupaten Karawang',
  },
  {
    id: '3216',
    provinceId: '32',
    name: 'Kabupaten Bekasi',
  },
  {
    id: '3217',
    provinceId: '32',
    name: 'Kabupaten Bandung Barat',
  },
  {
    id: '3218',
    provinceId: '32',
    name: 'Kabupaten Pangandaran',
  },
  {
    id: '3271',
    provinceId: '32',
    name: 'Kota Bogor',
  },
  {
    id: '3272',
    provinceId: '32',
    name: 'Kota Sukabumi',
  },
  {
    id: '3273',
    provinceId: '32',
    name: 'Kota Bandung',
  },
  {
    id: '3274',
    provinceId: '32',
    name: 'Kota Cirebon',
  },
  {
    id: '3275',
    provinceId: '32',
    name: 'Kota Bekasi',
  },
  {
    id: '3276',
    provinceId: '32',
    name: 'Kota Depok',
  },
  {
    id: '3277',
    provinceId: '32',
    name: 'Kota Cimahi',
  },
  {
    id: '3278',
    provinceId: '32',
    name: 'Kota Tasikmalaya',
  },
  {
    id: '3279',
    provinceId: '32',
    name: 'Kota Banjar',
  },
  {
    id: '3301',
    provinceId: '33',
    name: 'Kabupaten Cilacap',
  },
  {
    id: '3302',
    provinceId: '33',
    name: 'Kabupaten Banyumas',
  },
  {
    id: '3303',
    provinceId: '33',
    name: 'Kabupaten Purbalingga',
  },
  {
    id: '3304',
    provinceId: '33',
    name: 'Kabupaten Banjarnegara',
  },
  {
    id: '3305',
    provinceId: '33',
    name: 'Kabupaten Kebumen',
  },
  {
    id: '3306',
    provinceId: '33',
    name: 'Kabupaten Purworejo',
  },
  {
    id: '3307',
    provinceId: '33',
    name: 'Kabupaten Wonosobo',
  },
  {
    id: '3308',
    provinceId: '33',
    name: 'Kabupaten Magelang',
  },
  {
    id: '3309',
    provinceId: '33',
    name: 'Kabupaten Boyolali',
  },
  {
    id: '3310',
    provinceId: '33',
    name: 'Kabupaten Klaten',
  },
  {
    id: '3311',
    provinceId: '33',
    name: 'Kabupaten Sukoharjo',
  },
  {
    id: '3312',
    provinceId: '33',
    name: 'Kabupaten Wonogiri',
  },
  {
    id: '3313',
    provinceId: '33',
    name: 'Kabupaten Karanganyar',
  },
  {
    id: '3314',
    provinceId: '33',
    name: 'Kabupaten Sragen',
  },
  {
    id: '3315',
    provinceId: '33',
    name: 'Kabupaten Grobogan',
  },
  {
    id: '3316',
    provinceId: '33',
    name: 'Kabupaten Blora',
  },
  {
    id: '3317',
    provinceId: '33',
    name: 'Kabupaten Rembang',
  },
  {
    id: '3318',
    provinceId: '33',
    name: 'Kabupaten Pati',
  },
  {
    id: '3319',
    provinceId: '33',
    name: 'Kabupaten Kudus',
  },
  {
    id: '3320',
    provinceId: '33',
    name: 'Kabupaten Jepara',
  },
  {
    id: '3321',
    provinceId: '33',
    name: 'Kabupaten Demak',
  },
  {
    id: '3322',
    provinceId: '33',
    name: 'Kabupaten Semarang',
  },
  {
    id: '3323',
    provinceId: '33',
    name: 'Kabupaten Temanggung',
  },
  {
    id: '3324',
    provinceId: '33',
    name: 'Kabupaten Kendal',
  },
  {
    id: '3325',
    provinceId: '33',
    name: 'Kabupaten Batang',
  },
  {
    id: '3326',
    provinceId: '33',
    name: 'Kabupaten Pekalongan',
  },
  {
    id: '3327',
    provinceId: '33',
    name: 'Kabupaten Pemalang',
  },
  {
    id: '3328',
    provinceId: '33',
    name: 'Kabupaten Tegal',
  },
  {
    id: '3329',
    provinceId: '33',
    name: 'Kabupaten Brebes',
  },
  {
    id: '3371',
    provinceId: '33',
    name: 'Kota Magelang',
  },
  {
    id: '3372',
    provinceId: '33',
    name: 'Kota Surakarta',
  },
  {
    id: '3373',
    provinceId: '33',
    name: 'Kota Salatiga',
  },
  {
    id: '3374',
    provinceId: '33',
    name: 'Kota Semarang',
  },
  {
    id: '3375',
    provinceId: '33',
    name: 'Kota Pekalongan',
  },
  {
    id: '3376',
    provinceId: '33',
    name: 'Kota Tegal',
  },
  {
    id: '3401',
    provinceId: '34',
    name: 'Kabupaten Kulon Progo',
  },
  {
    id: '3402',
    provinceId: '34',
    name: 'Kabupaten Bantul',
  },
  {
    id: '3403',
    provinceId: '34',
    name: 'Kabupaten Gunung Kidul',
  },
  {
    id: '3404',
    provinceId: '34',
    name: 'Kabupaten Sleman',
  },
  {
    id: '3471',
    provinceId: '34',
    name: 'Kota Yogyakarta',
  },
  {
    id: '3501',
    provinceId: '35',
    name: 'Kabupaten Pacitan',
  },
  {
    id: '3502',
    provinceId: '35',
    name: 'Kabupaten Ponorogo',
  },
  {
    id: '3503',
    provinceId: '35',
    name: 'Kabupaten Trenggalek',
  },
  {
    id: '3504',
    provinceId: '35',
    name: 'Kabupaten Tulungagung',
  },
  {
    id: '3505',
    provinceId: '35',
    name: 'Kabupaten Blitar',
  },
  {
    id: '3506',
    provinceId: '35',
    name: 'Kabupaten Kediri',
  },
  {
    id: '3507',
    provinceId: '35',
    name: 'Kabupaten Malang',
  },
  {
    id: '3508',
    provinceId: '35',
    name: 'Kabupaten Lumajang',
  },
  {
    id: '3509',
    provinceId: '35',
    name: 'Kabupaten Jember',
  },
  {
    id: '3510',
    provinceId: '35',
    name: 'Kabupaten Banyuwangi',
  },
  {
    id: '3511',
    provinceId: '35',
    name: 'Kabupaten Bondowoso',
  },
  {
    id: '3512',
    provinceId: '35',
    name: 'Kabupaten Situbondo',
  },
  {
    id: '3513',
    provinceId: '35',
    name: 'Kabupaten Probolinggo',
  },
  {
    id: '3514',
    provinceId: '35',
    name: 'Kabupaten Pasuruan',
  },
  {
    id: '3515',
    provinceId: '35',
    name: 'Kabupaten Sidoarjo',
  },
  {
    id: '3516',
    provinceId: '35',
    name: 'Kabupaten Mojokerto',
  },
  {
    id: '3517',
    provinceId: '35',
    name: 'Kabupaten Jombang',
  },
  {
    id: '3518',
    provinceId: '35',
    name: 'Kabupaten Nganjuk',
  },
  {
    id: '3519',
    provinceId: '35',
    name: 'Kabupaten Madiun',
  },
  {
    id: '3520',
    provinceId: '35',
    name: 'Kabupaten Magetan',
  },
  {
    id: '3521',
    provinceId: '35',
    name: 'Kabupaten Ngawi',
  },
  {
    id: '3522',
    provinceId: '35',
    name: 'Kabupaten Bojonegoro',
  },
  {
    id: '3523',
    provinceId: '35',
    name: 'Kabupaten Tuban',
  },
  {
    id: '3524',
    provinceId: '35',
    name: 'Kabupaten Lamongan',
  },
  {
    id: '3525',
    provinceId: '35',
    name: 'Kabupaten Gresik',
  },
  {
    id: '3526',
    provinceId: '35',
    name: 'Kabupaten Bangkalan',
  },
  {
    id: '3527',
    provinceId: '35',
    name: 'Kabupaten Sampang',
  },
  {
    id: '3528',
    provinceId: '35',
    name: 'Kabupaten Pamekasan',
  },
  {
    id: '3529',
    provinceId: '35',
    name: 'Kabupaten Sumenep',
  },
  {
    id: '3571',
    provinceId: '35',
    name: 'Kota Kediri',
  },
  {
    id: '3572',
    provinceId: '35',
    name: 'Kota Blitar',
  },
  {
    id: '3573',
    provinceId: '35',
    name: 'Kota Malang',
  },
  {
    id: '3574',
    provinceId: '35',
    name: 'Kota Probolinggo',
  },
  {
    id: '3575',
    provinceId: '35',
    name: 'Kota Pasuruan',
  },
  {
    id: '3576',
    provinceId: '35',
    name: 'Kota Mojokerto',
  },
  {
    id: '3577',
    provinceId: '35',
    name: 'Kota Madiun',
  },
  {
    id: '3578',
    provinceId: '35',
    name: 'Kota Surabaya',
  },
  {
    id: '3579',
    provinceId: '35',
    name: 'Kota Batu',
  },
  {
    id: '3601',
    provinceId: '36',
    name: 'Kabupaten Pandeglang',
  },
  {
    id: '3602',
    provinceId: '36',
    name: 'Kabupaten Lebak',
  },
  {
    id: '3603',
    provinceId: '36',
    name: 'Kabupaten Tangerang',
  },
  {
    id: '3604',
    provinceId: '36',
    name: 'Kabupaten Serang',
  },
  {
    id: '3671',
    provinceId: '36',
    name: 'Kota Tangerang',
  },
  {
    id: '3672',
    provinceId: '36',
    name: 'Kota Cilegon',
  },
  {
    id: '3673',
    provinceId: '36',
    name: 'Kota Serang',
  },
  {
    id: '3674',
    provinceId: '36',
    name: 'Kota Tangerang Selatan',
  },
  {
    id: '5101',
    provinceId: '51',
    name: 'Kabupaten Jembrana',
  },
  {
    id: '5102',
    provinceId: '51',
    name: 'Kabupaten Tabanan',
  },
  {
    id: '5103',
    provinceId: '51',
    name: 'Kabupaten Badung',
  },
  {
    id: '5104',
    provinceId: '51',
    name: 'Kabupaten Gianyar',
  },
  {
    id: '5105',
    provinceId: '51',
    name: 'Kabupaten Klungkung',
  },
  {
    id: '5106',
    provinceId: '51',
    name: 'Kabupaten Bangli',
  },
  {
    id: '5107',
    provinceId: '51',
    name: 'Kabupaten Karang Asem',
  },
  {
    id: '5108',
    provinceId: '51',
    name: 'Kabupaten Buleleng',
  },
  {
    id: '5171',
    provinceId: '51',
    name: 'Kota Denpasar',
  },
  {
    id: '5201',
    provinceId: '52',
    name: 'Kabupaten Lombok Barat',
  },
  {
    id: '5202',
    provinceId: '52',
    name: 'Kabupaten Lombok Tengah',
  },
  {
    id: '5203',
    provinceId: '52',
    name: 'Kabupaten Lombok Timur',
  },
  {
    id: '5204',
    provinceId: '52',
    name: 'Kabupaten Sumbawa',
  },
  {
    id: '5205',
    provinceId: '52',
    name: 'Kabupaten Dompu',
  },
  {
    id: '5206',
    provinceId: '52',
    name: 'Kabupaten Bima',
  },
  {
    id: '5207',
    provinceId: '52',
    name: 'Kabupaten Sumbawa Barat',
  },
  {
    id: '5208',
    provinceId: '52',
    name: 'Kabupaten Lombok Utara',
  },
  {
    id: '5271',
    provinceId: '52',
    name: 'Kota Mataram',
  },
  {
    id: '5272',
    provinceId: '52',
    name: 'Kota Bima',
  },
  {
    id: '5301',
    provinceId: '53',
    name: 'Kabupaten Sumba Barat',
  },
  {
    id: '5302',
    provinceId: '53',
    name: 'Kabupaten Sumba Timur',
  },
  {
    id: '5303',
    provinceId: '53',
    name: 'Kabupaten Kupang',
  },
  {
    id: '5304',
    provinceId: '53',
    name: 'Kabupaten Timor Tengah Selatan',
  },
  {
    id: '5305',
    provinceId: '53',
    name: 'Kabupaten Timor Tengah Utara',
  },
  {
    id: '5306',
    provinceId: '53',
    name: 'Kabupaten Belu',
  },
  {
    id: '5307',
    provinceId: '53',
    name: 'Kabupaten Alor',
  },
  {
    id: '5308',
    provinceId: '53',
    name: 'Kabupaten Lembata',
  },
  {
    id: '5309',
    provinceId: '53',
    name: 'Kabupaten Flores Timur',
  },
  {
    id: '5310',
    provinceId: '53',
    name: 'Kabupaten Sikka',
  },
  {
    id: '5311',
    provinceId: '53',
    name: 'Kabupaten Ende',
  },
  {
    id: '5312',
    provinceId: '53',
    name: 'Kabupaten Ngada',
  },
  {
    id: '5313',
    provinceId: '53',
    name: 'Kabupaten Manggarai',
  },
  {
    id: '5314',
    provinceId: '53',
    name: 'Kabupaten Rote Ndao',
  },
  {
    id: '5315',
    provinceId: '53',
    name: 'Kabupaten Manggarai Barat',
  },
  {
    id: '5316',
    provinceId: '53',
    name: 'Kabupaten Sumba Tengah',
  },
  {
    id: '5317',
    provinceId: '53',
    name: 'Kabupaten Sumba Barat Daya',
  },
  {
    id: '5318',
    provinceId: '53',
    name: 'Kabupaten Nagekeo',
  },
  {
    id: '5319',
    provinceId: '53',
    name: 'Kabupaten Manggarai Timur',
  },
  {
    id: '5320',
    provinceId: '53',
    name: 'Kabupaten Sabu Raijua',
  },
  {
    id: '5321',
    provinceId: '53',
    name: 'Kabupaten Malaka',
  },
  {
    id: '5371',
    provinceId: '53',
    name: 'Kota Kupang',
  },
  {
    id: '6101',
    provinceId: '61',
    name: 'Kabupaten Sambas',
  },
  {
    id: '6102',
    provinceId: '61',
    name: 'Kabupaten Bengkayang',
  },
  {
    id: '6103',
    provinceId: '61',
    name: 'Kabupaten Landak',
  },
  {
    id: '6104',
    provinceId: '61',
    name: 'Kabupaten Mempawah',
  },
  {
    id: '6105',
    provinceId: '61',
    name: 'Kabupaten Sanggau',
  },
  {
    id: '6106',
    provinceId: '61',
    name: 'Kabupaten Ketapang',
  },
  {
    id: '6107',
    provinceId: '61',
    name: 'Kabupaten Sintang',
  },
  {
    id: '6108',
    provinceId: '61',
    name: 'Kabupaten Kapuas Hulu',
  },
  {
    id: '6109',
    provinceId: '61',
    name: 'Kabupaten Sekadau',
  },
  {
    id: '6110',
    provinceId: '61',
    name: 'Kabupaten Melawi',
  },
  {
    id: '6111',
    provinceId: '61',
    name: 'Kabupaten Kayong Utara',
  },
  {
    id: '6112',
    provinceId: '61',
    name: 'Kabupaten Kubu Raya',
  },
  {
    id: '6171',
    provinceId: '61',
    name: 'Kota Pontianak',
  },
  {
    id: '6172',
    provinceId: '61',
    name: 'Kota Singkawang',
  },
  {
    id: '6201',
    provinceId: '62',
    name: 'Kabupaten Kotawaringin Barat',
  },
  {
    id: '6202',
    provinceId: '62',
    name: 'Kabupaten Kotawaringin Timur',
  },
  {
    id: '6203',
    provinceId: '62',
    name: 'Kabupaten Kapuas',
  },
  {
    id: '6204',
    provinceId: '62',
    name: 'Kabupaten Barito Selatan',
  },
  {
    id: '6205',
    provinceId: '62',
    name: 'Kabupaten Barito Utara',
  },
  {
    id: '6206',
    provinceId: '62',
    name: 'Kabupaten Sukamara',
  },
  {
    id: '6207',
    provinceId: '62',
    name: 'Kabupaten Lamandau',
  },
  {
    id: '6208',
    provinceId: '62',
    name: 'Kabupaten Seruyan',
  },
  {
    id: '6209',
    provinceId: '62',
    name: 'Kabupaten Katingan',
  },
  {
    id: '6210',
    provinceId: '62',
    name: 'Kabupaten Pulang Pisau',
  },
  {
    id: '6211',
    provinceId: '62',
    name: 'Kabupaten Gunung Mas',
  },
  {
    id: '6212',
    provinceId: '62',
    name: 'Kabupaten Barito Timur',
  },
  {
    id: '6213',
    provinceId: '62',
    name: 'Kabupaten Murung Raya',
  },
  {
    id: '6271',
    provinceId: '62',
    name: 'Kota Palangka Raya',
  },
  {
    id: '6301',
    provinceId: '63',
    name: 'Kabupaten Tanah Laut',
  },
  {
    id: '6302',
    provinceId: '63',
    name: 'Kabupaten Kota Baru',
  },
  {
    id: '6303',
    provinceId: '63',
    name: 'Kabupaten Banjar',
  },
  {
    id: '6304',
    provinceId: '63',
    name: 'Kabupaten Barito Kuala',
  },
  {
    id: '6305',
    provinceId: '63',
    name: 'Kabupaten Tapin',
  },
  {
    id: '6306',
    provinceId: '63',
    name: 'Kabupaten Hulu Sungai Selatan',
  },
  {
    id: '6307',
    provinceId: '63',
    name: 'Kabupaten Hulu Sungai Tengah',
  },
  {
    id: '6308',
    provinceId: '63',
    name: 'Kabupaten Hulu Sungai Utara',
  },
  {
    id: '6309',
    provinceId: '63',
    name: 'Kabupaten Tabalong',
  },
  {
    id: '6310',
    provinceId: '63',
    name: 'Kabupaten Tanah Bumbu',
  },
  {
    id: '6311',
    provinceId: '63',
    name: 'Kabupaten Balangan',
  },
  {
    id: '6371',
    provinceId: '63',
    name: 'Kota Banjarmasin',
  },
  {
    id: '6372',
    provinceId: '63',
    name: 'Kota Banjar Baru',
  },
  {
    id: '6401',
    provinceId: '64',
    name: 'Kabupaten Paser',
  },
  {
    id: '6402',
    provinceId: '64',
    name: 'Kabupaten Kutai Barat',
  },
  {
    id: '6403',
    provinceId: '64',
    name: 'Kabupaten Kutai Kartanegara',
  },
  {
    id: '6404',
    provinceId: '64',
    name: 'Kabupaten Kutai Timur',
  },
  {
    id: '6405',
    provinceId: '64',
    name: 'Kabupaten Berau',
  },
  {
    id: '6409',
    provinceId: '64',
    name: 'Kabupaten Penajam Paser Utara',
  },
  {
    id: '6411',
    provinceId: '64',
    name: 'Kabupaten Mahakam Hulu',
  },
  {
    id: '6471',
    provinceId: '64',
    name: 'Kota Balikpapan',
  },
  {
    id: '6472',
    provinceId: '64',
    name: 'Kota Samarinda',
  },
  {
    id: '6474',
    provinceId: '64',
    name: 'Kota Bontang',
  },
  {
    id: '6501',
    provinceId: '65',
    name: 'Kabupaten Malinau',
  },
  {
    id: '6502',
    provinceId: '65',
    name: 'Kabupaten Bulungan',
  },
  {
    id: '6503',
    provinceId: '65',
    name: 'Kabupaten Tana Tidung',
  },
  {
    id: '6504',
    provinceId: '65',
    name: 'Kabupaten Nunukan',
  },
  {
    id: '6571',
    provinceId: '65',
    name: 'Kota Tarakan',
  },
  {
    id: '7101',
    provinceId: '71',
    name: 'Kabupaten Bolaang Mongondow',
  },
  {
    id: '7102',
    provinceId: '71',
    name: 'Kabupaten Minahasa',
  },
  {
    id: '7103',
    provinceId: '71',
    name: 'Kabupaten Kepulauan Sangihe',
  },
  {
    id: '7104',
    provinceId: '71',
    name: 'Kabupaten Kepulauan Talaud',
  },
  {
    id: '7105',
    provinceId: '71',
    name: 'Kabupaten Minahasa Selatan',
  },
  {
    id: '7106',
    provinceId: '71',
    name: 'Kabupaten Minahasa Utara',
  },
  {
    id: '7107',
    provinceId: '71',
    name: 'Kabupaten Bolaang Mongondow Utara',
  },
  {
    id: '7108',
    provinceId: '71',
    name: 'Kabupaten Siau Tagulandang Biaro',
  },
  {
    id: '7109',
    provinceId: '71',
    name: 'Kabupaten Minahasa Tenggara',
  },
  {
    id: '7110',
    provinceId: '71',
    name: 'Kabupaten Bolaang Mongondow Selatan',
  },
  {
    id: '7111',
    provinceId: '71',
    name: 'Kabupaten Bolaang Mongondow Timur',
  },
  {
    id: '7171',
    provinceId: '71',
    name: 'Kota Manado',
  },
  {
    id: '7172',
    provinceId: '71',
    name: 'Kota Bitung',
  },
  {
    id: '7173',
    provinceId: '71',
    name: 'Kota Tomohon',
  },
  {
    id: '7174',
    provinceId: '71',
    name: 'Kota Kotamobagu',
  },
  {
    id: '7201',
    provinceId: '72',
    name: 'Kabupaten Banggai Kepulauan',
  },
  {
    id: '7202',
    provinceId: '72',
    name: 'Kabupaten Banggai',
  },
  {
    id: '7203',
    provinceId: '72',
    name: 'Kabupaten Morowali',
  },
  {
    id: '7204',
    provinceId: '72',
    name: 'Kabupaten Poso',
  },
  {
    id: '7205',
    provinceId: '72',
    name: 'Kabupaten Donggala',
  },
  {
    id: '7206',
    provinceId: '72',
    name: 'Kabupaten Toli-Toli',
  },
  {
    id: '7207',
    provinceId: '72',
    name: 'Kabupaten Buol',
  },
  {
    id: '7208',
    provinceId: '72',
    name: 'Kabupaten Parigi Moutong',
  },
  {
    id: '7209',
    provinceId: '72',
    name: 'Kabupaten Tojo Una-Una',
  },
  {
    id: '7210',
    provinceId: '72',
    name: 'Kabupaten Sigi',
  },
  {
    id: '7211',
    provinceId: '72',
    name: 'Kabupaten Banggai Laut',
  },
  {
    id: '7212',
    provinceId: '72',
    name: 'Kabupaten Morowali Utara',
  },
  {
    id: '7271',
    provinceId: '72',
    name: 'Kota Palu',
  },
  {
    id: '7301',
    provinceId: '73',
    name: 'Kabupaten Kepulauan Selayar',
  },
  {
    id: '7302',
    provinceId: '73',
    name: 'Kabupaten Bulukumba',
  },
  {
    id: '7303',
    provinceId: '73',
    name: 'Kabupaten Bantaeng',
  },
  {
    id: '7304',
    provinceId: '73',
    name: 'Kabupaten Jeneponto',
  },
  {
    id: '7305',
    provinceId: '73',
    name: 'Kabupaten Takalar',
  },
  {
    id: '7306',
    provinceId: '73',
    name: 'Kabupaten Gowa',
  },
  {
    id: '7307',
    provinceId: '73',
    name: 'Kabupaten Sinjai',
  },
  {
    id: '7308',
    provinceId: '73',
    name: 'Kabupaten Maros',
  },
  {
    id: '7309',
    provinceId: '73',
    name: 'Kabupaten Pangkajene Dan Kepulauan',
  },
  {
    id: '7310',
    provinceId: '73',
    name: 'Kabupaten Barru',
  },
  {
    id: '7311',
    provinceId: '73',
    name: 'Kabupaten Bone',
  },
  {
    id: '7312',
    provinceId: '73',
    name: 'Kabupaten Soppeng',
  },
  {
    id: '7313',
    provinceId: '73',
    name: 'Kabupaten Wajo',
  },
  {
    id: '7314',
    provinceId: '73',
    name: 'Kabupaten Sidenreng Rappang',
  },
  {
    id: '7315',
    provinceId: '73',
    name: 'Kabupaten Pinrang',
  },
  {
    id: '7316',
    provinceId: '73',
    name: 'Kabupaten Enrekang',
  },
  {
    id: '7317',
    provinceId: '73',
    name: 'Kabupaten Luwu',
  },
  {
    id: '7318',
    provinceId: '73',
    name: 'Kabupaten Tana Toraja',
  },
  {
    id: '7322',
    provinceId: '73',
    name: 'Kabupaten Luwu Utara',
  },
  {
    id: '7325',
    provinceId: '73',
    name: 'Kabupaten Luwu Timur',
  },
  {
    id: '7326',
    provinceId: '73',
    name: 'Kabupaten Toraja Utara',
  },
  {
    id: '7371',
    provinceId: '73',
    name: 'Kota Makassar',
  },
  {
    id: '7372',
    provinceId: '73',
    name: 'Kota Parepare',
  },
  {
    id: '7373',
    provinceId: '73',
    name: 'Kota Palopo',
  },
  {
    id: '7401',
    provinceId: '74',
    name: 'Kabupaten Buton',
  },
  {
    id: '7402',
    provinceId: '74',
    name: 'Kabupaten Muna',
  },
  {
    id: '7403',
    provinceId: '74',
    name: 'Kabupaten Konawe',
  },
  {
    id: '7404',
    provinceId: '74',
    name: 'Kabupaten Kolaka',
  },
  {
    id: '7405',
    provinceId: '74',
    name: 'Kabupaten Konawe Selatan',
  },
  {
    id: '7406',
    provinceId: '74',
    name: 'Kabupaten Bombana',
  },
  {
    id: '7407',
    provinceId: '74',
    name: 'Kabupaten Wakatobi',
  },
  {
    id: '7408',
    provinceId: '74',
    name: 'Kabupaten Kolaka Utara',
  },
  {
    id: '7409',
    provinceId: '74',
    name: 'Kabupaten Buton Utara',
  },
  {
    id: '7410',
    provinceId: '74',
    name: 'Kabupaten Konawe Utara',
  },
  {
    id: '7411',
    provinceId: '74',
    name: 'Kabupaten Kolaka Timur',
  },
  {
    id: '7412',
    provinceId: '74',
    name: 'Kabupaten Konawe Kepulauan',
  },
  {
    id: '7413',
    provinceId: '74',
    name: 'Kabupaten Muna Barat',
  },
  {
    id: '7414',
    provinceId: '74',
    name: 'Kabupaten Buton Tengah',
  },
  {
    id: '7415',
    provinceId: '74',
    name: 'Kabupaten Buton Selatan',
  },
  {
    id: '7471',
    provinceId: '74',
    name: 'Kota Kendari',
  },
  {
    id: '7472',
    provinceId: '74',
    name: 'Kota Baubau',
  },
  {
    id: '7501',
    provinceId: '75',
    name: 'Kabupaten Boalemo',
  },
  {
    id: '7502',
    provinceId: '75',
    name: 'Kabupaten Gorontalo',
  },
  {
    id: '7503',
    provinceId: '75',
    name: 'Kabupaten Pohuwato',
  },
  {
    id: '7504',
    provinceId: '75',
    name: 'Kabupaten Bone Bolango',
  },
  {
    id: '7505',
    provinceId: '75',
    name: 'Kabupaten Gorontalo Utara',
  },
  {
    id: '7571',
    provinceId: '75',
    name: 'Kota Gorontalo',
  },
  {
    id: '7601',
    provinceId: '76',
    name: 'Kabupaten Majene',
  },
  {
    id: '7602',
    provinceId: '76',
    name: 'Kabupaten Polewali Mandar',
  },
  {
    id: '7603',
    provinceId: '76',
    name: 'Kabupaten Mamasa',
  },
  {
    id: '7604',
    provinceId: '76',
    name: 'Kabupaten Mamuju',
  },
  {
    id: '7605',
    provinceId: '76',
    name: 'Kabupaten Mamuju Utara',
  },
  {
    id: '7606',
    provinceId: '76',
    name: 'Kabupaten Mamuju Tengah',
  },
  {
    id: '8101',
    provinceId: '81',
    name: 'Kabupaten Maluku Tenggara Barat',
  },
  {
    id: '8102',
    provinceId: '81',
    name: 'Kabupaten Maluku Tenggara',
  },
  {
    id: '8103',
    provinceId: '81',
    name: 'Kabupaten Maluku Tengah',
  },
  {
    id: '8104',
    provinceId: '81',
    name: 'Kabupaten Buru',
  },
  {
    id: '8105',
    provinceId: '81',
    name: 'Kabupaten Kepulauan Aru',
  },
  {
    id: '8106',
    provinceId: '81',
    name: 'Kabupaten Seram Bagian Barat',
  },
  {
    id: '8107',
    provinceId: '81',
    name: 'Kabupaten Seram Bagian Timur',
  },
  {
    id: '8108',
    provinceId: '81',
    name: 'Kabupaten Maluku Barat Daya',
  },
  {
    id: '8109',
    provinceId: '81',
    name: 'Kabupaten Buru Selatan',
  },
  {
    id: '8171',
    provinceId: '81',
    name: 'Kota Ambon',
  },
  {
    id: '8172',
    provinceId: '81',
    name: 'Kota Tual',
  },
  {
    id: '8201',
    provinceId: '82',
    name: 'Kabupaten Halmahera Barat',
  },
  {
    id: '8202',
    provinceId: '82',
    name: 'Kabupaten Halmahera Tengah',
  },
  {
    id: '8203',
    provinceId: '82',
    name: 'Kabupaten Kepulauan Sula',
  },
  {
    id: '8204',
    provinceId: '82',
    name: 'Kabupaten Halmahera Selatan',
  },
  {
    id: '8205',
    provinceId: '82',
    name: 'Kabupaten Halmahera Utara',
  },
  {
    id: '8206',
    provinceId: '82',
    name: 'Kabupaten Halmahera Timur',
  },
  {
    id: '8207',
    provinceId: '82',
    name: 'Kabupaten Pulau Morotai',
  },
  {
    id: '8208',
    provinceId: '82',
    name: 'Kabupaten Pulau Taliabu',
  },
  {
    id: '8271',
    provinceId: '82',
    name: 'Kota Ternate',
  },
  {
    id: '8272',
    provinceId: '82',
    name: 'Kota Tidore Kepulauan',
  },
  {
    id: '9101',
    provinceId: '91',
    name: 'Kabupaten Fakfak',
  },
  {
    id: '9102',
    provinceId: '91',
    name: 'Kabupaten Kaimana',
  },
  {
    id: '9103',
    provinceId: '91',
    name: 'Kabupaten Teluk Wondama',
  },
  {
    id: '9104',
    provinceId: '91',
    name: 'Kabupaten Teluk Bintuni',
  },
  {
    id: '9105',
    provinceId: '91',
    name: 'Kabupaten Manokwari',
  },
  {
    id: '9106',
    provinceId: '91',
    name: 'Kabupaten Sorong Selatan',
  },
  {
    id: '9107',
    provinceId: '91',
    name: 'Kabupaten Sorong',
  },
  {
    id: '9108',
    provinceId: '91',
    name: 'Kabupaten Raja Ampat',
  },
  {
    id: '9109',
    provinceId: '91',
    name: 'Kabupaten Tambrauw',
  },
  {
    id: '9110',
    provinceId: '91',
    name: 'Kabupaten Maybrat',
  },
  {
    id: '9111',
    provinceId: '91',
    name: 'Kabupaten Manokwari Selatan',
  },
  {
    id: '9112',
    provinceId: '91',
    name: 'Kabupaten Pegunungan Arfak',
  },
  {
    id: '9171',
    provinceId: '91',
    name: 'Kota Sorong',
  },
  {
    id: '9401',
    provinceId: '94',
    name: 'Kabupaten Merauke',
  },
  {
    id: '9402',
    provinceId: '94',
    name: 'Kabupaten Jayawijaya',
  },
  {
    id: '9403',
    provinceId: '94',
    name: 'Kabupaten Jayapura',
  },
  {
    id: '9404',
    provinceId: '94',
    name: 'Kabupaten Nabire',
  },
  {
    id: '9408',
    provinceId: '94',
    name: 'Kabupaten Kepulauan Yapen',
  },
  {
    id: '9409',
    provinceId: '94',
    name: 'Kabupaten Biak Numfor',
  },
  {
    id: '9410',
    provinceId: '94',
    name: 'Kabupaten Paniai',
  },
  {
    id: '9411',
    provinceId: '94',
    name: 'Kabupaten Puncak Jaya',
  },
  {
    id: '9412',
    provinceId: '94',
    name: 'Kabupaten Mimika',
  },
  {
    id: '9413',
    provinceId: '94',
    name: 'Kabupaten Boven Digoel',
  },
  {
    id: '9414',
    provinceId: '94',
    name: 'Kabupaten Mappi',
  },
  {
    id: '9415',
    provinceId: '94',
    name: 'Kabupaten Asmat',
  },
  {
    id: '9416',
    provinceId: '94',
    name: 'Kabupaten Yahukimo',
  },
  {
    id: '9417',
    provinceId: '94',
    name: 'Kabupaten Pegunungan Bintang',
  },
  {
    id: '9418',
    provinceId: '94',
    name: 'Kabupaten Tolikara',
  },
  {
    id: '9419',
    provinceId: '94',
    name: 'Kabupaten Sarmi',
  },
  {
    id: '9420',
    provinceId: '94',
    name: 'Kabupaten Keerom',
  },
  {
    id: '9426',
    provinceId: '94',
    name: 'Kabupaten Waropen',
  },
  {
    id: '9427',
    provinceId: '94',
    name: 'Kabupaten Supiori',
  },
  {
    id: '9428',
    provinceId: '94',
    name: 'Kabupaten Mamberamo Raya',
  },
  {
    id: '9429',
    provinceId: '94',
    name: 'Kabupaten Nduga',
  },
  {
    id: '9430',
    provinceId: '94',
    name: 'Kabupaten Lanny Jaya',
  },
  {
    id: '9431',
    provinceId: '94',
    name: 'Kabupaten Mamberamo Tengah',
  },
  {
    id: '9432',
    provinceId: '94',
    name: 'Kabupaten Yalimo',
  },
  {
    id: '9433',
    provinceId: '94',
    name: 'Kabupaten Puncak',
  },
  {
    id: '9434',
    provinceId: '94',
    name: 'Kabupaten Dogiyai',
  },
  {
    id: '9435',
    provinceId: '94',
    name: 'Kabupaten Intan Jaya',
  },
  {
    id: '9436',
    provinceId: '94',
    name: 'Kabupaten Deiyai',
  },
  {
    id: '9471',
    provinceId: '94',
    name: 'Kota Jayapura',
  },
]
